/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Billing_Resets_TooltipInputs */



/**
* | output |
* | --- |
* | "Your pool refills and any extra usage clears at the start of each billing period." |
*
* @param {Dashboard_Billing_Resets_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_billing_resets_tooltip = /** @type {((inputs?: Dashboard_Billing_Resets_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Billing_Resets_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihr Pool wird zu Beginn jeder Abrechnungsperiode aufgefüllt und die Zusatznutzung zurückgesetzt.")
	return /** @type {LocalizedString} */ ("Your pool refills and any extra usage clears at the start of each billing period.")
});